<div clas="portal-menu-wrapper">
  <div class="menu-title-container">
    <span class="menu-title">{{resource.getViewLabel("Global_Text_Menu")}}</span>
    <button (click)="sidenav.close()" mat-icon-button aria-label="close" class="portal-menu-wrapper-item">
        <mat-icon>clear</mat-icon>
    </button>
  </div>
  <portal-menu [menu]="menus" [menuKey]="menuKey"></portal-menu>
</div>